import { useState } from "react";
import type { IPeriodOverPeriodChartState } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/types";
import { getInitialChartState } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/utils/getInitialChartState";
import { PeriodOverPeriodChartWrapper } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/common/ChartWrapper";
import styled from "styled-components";
import { Header } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/size-and-growth-period-over-period/Header";
import { parseRawDataHof } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/size-and-growth-period-over-period/parseRawDataHof";
import { getChartConfigHof } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/size-and-growth-period-over-period/getChartConfig";
import { Legends } from "app/pages/industry-analysis/segmentation/size-and-growth-overview/size-and-growth-period-over-period/Legends";

const Container = styled.div``;

export const SizeAndGrowthPeriodOverPeriod = () => {
    const [chartState, setChartState] = useState<IPeriodOverPeriodChartState>(getInitialChartState);
    return (
        <Container>
            <Header />
            <Legends
                chartState={chartState}
                setChartState={setChartState}
            />
            <PeriodOverPeriodChartWrapper
                chartState={chartState}
                setChartState={setChartState}
                parseRawData={parseRawDataHof()}
                getChartConfig={getChartConfigHof(chartState)}
            />
        </Container>
    );
};
